<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GoznYN/images/cover.jpg?1696557737941" alt="This image is the cover for the book Monkey and the Maize"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monkey and the Maize
      </h1>
      <p class="bookDescription body article font2">
        <b>An allegorical tale that teaches core lifetime and business management principles through the life story of a monkey named Pete.</b><br/><br/>Meet Pete. As a young monkey growing up on the safe side of The Hedge, he longs for adventure, fame, and fortune, and eventually leaves the security of his home to explore new horizons. Along the way, Pete becomes a husband, a father, and a business leader. New communities, characters and experiences present opportunities to learn management and life skills. Pete eventually reaches The City and is tasked with managing the critical shortage of The City’s primary resource. Pete is sent on a risky journey to find more resources and uncovers impending catastrophe heading toward his home community and The City. All of Pete’s leadership skills are tested as he races to save his family, his community, and even his foes from certain destruction.<br/><br/><i>The Monkey and the Maize</i> is a fictional story with core messages about leadership, management, community and integrity that span multiple life roles—from a young couple learning how to be good parents to a first-time manager learning how to lead to a corporate CEO who wants to continue to grow. The five roots of life—Faith, Family, Fellowship, Food [Work], and Forgiveness—are woven throughout this tale providing its firm foundation.<br/><br/><b>“Mr. Marble hasn’t just penned another book on leadership. At the core, he brilliantly describes a journey that is both relatable yet inspiring. <i>The Monkey and the Maize</i> will create a moment of self-reflection and awareness for its readers by being real, not superficially didactic.” —Dave Kipe, Chief Operating Officer, Majestic Steel USA</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S. Mosby Marble
      </h2>
      
      <p class="authorDescription body article"><B>Steven Marble</B> is a lifelong entrepreneur and corporate leader with over thirty years of leadership experience. He completed his undergraduate degrees while owning a small business then transitioned to the corporate world and completed his MBA in 1999. Since that time, Marble has served in various leadership roles from General Manager to Vice President in fields from Customer Service to Human Resources to Operations, specializing in operational optimization and change leadership. He spent over 23 years in senior leadership roles for Scholastic Book Publishing and Charter/Spectrum; the last 14 were executive roles. Marble is a Christian and devotes his purpose to the teachings of Christ through word and deed.<P> Steven has been married for 32 years and has three children and a grandchild. He lives in Jefferson City, MO.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4d99a68